module.exports = __webpack_public_path__ + "static/media/fotogalereya11.fd039b51.jpg";